import useSWR from 'swr'

import {
  GetOutboxVars,
  ListOutboxVars,
  ListRegFunctionsVars,
  OutboxDetailResponse,
  OutboxListResponse,
  PromotionOutboxApiPath,
  RegFunctionsResponse
} from '@/common/api/params/promotionOutbox'

// 登録機能カタログ（施策・登録機能・対象テーブル）
export const usePromotionOutboxFunctionsApi = () => {
  return useSWR<RegFunctionsResponse, Response, [string, ListRegFunctionsVars]>([
    PromotionOutboxApiPath.LIST_FUNCTIONS,
    {}
  ])
}

// 一覧（サイト単位）
export const usePromotionOutboxListApi = (vars: ListOutboxVars | undefined) => {
  return useSWR<OutboxListResponse, Response, [string, ListOutboxVars] | undefined>(
    vars ? [PromotionOutboxApiPath.LIST, vars] : undefined
  )
}

// 詳細
export const usePromotionOutboxDetailApi = (vars: GetOutboxVars | undefined) => {
  return useSWR<OutboxDetailResponse, Response, [string, GetOutboxVars] | undefined>(
    vars ? [PromotionOutboxApiPath.DETAIL, vars] : undefined
  )
}
